import type { FrontrowGatewayApp } from "gateway-frontrow";
import { type AppClientOptions, appClient } from "./client";

// Client of the Frontrow app (ADR-040, ADR-216): the access of the external users at /auth (ADR-206); the domains'
// routes under /api, with their steps (P8.1e, P8.1f).

export function frontrowClient(options: AppClientOptions = {}) {
  const { api, root } = appClient<FrontrowGatewayApp>(options);
  return { api, auth: root.auth };
}
